export function calculateAgeFromDob(dateOfBirth) {
  if (!dateOfBirth) return null;

  const birthDate = new Date(dateOfBirth);
  if (Number.isNaN(birthDate.getTime())) return null;

  const now = new Date();
  let age = now.getFullYear() - birthDate.getFullYear();
  const monthDiff = now.getMonth() - birthDate.getMonth();

  if (monthDiff < 0 || (monthDiff === 0 && now.getDate() < birthDate.getDate())) {
    age -= 1;
  }

  return age;
}

export function isAtLeastAge(dateOfBirth, minimumAge) {
  const age = calculateAgeFromDob(dateOfBirth);
  if (age === null) return false;
  return age >= minimumAge;
}
